// extracted by mini-css-extract-plugin
export default {"issueImageContainer":"IssueImage_issueImageContainer__HCaCQ"};